import { Helmet } from 'react-helmet-async';
// @mui
import { Button, Container, Typography } from '@mui/material';
// components

import React from 'react';
import { LicenseInfo } from '@mui/x-license-pro';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useSettingsContext } from '../components/settings';
import DealerWarrantyRegistrationTable from '../sections/tables/DealerWarrantyRegistration';

LicenseInfo.setLicenseKey(
  '27c495e67f4950c3d812be544d2aded4Tz02MzYxNyxFPTE3MTIyNTAzNjQ2MjQsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
);
// ----------------------------------------------------------------------

export default function DealerWarrantyRegistrationPage() {
  const { themeStretch } = useSettingsContext();
  const { id } = useParams();

  return (
    <>
      <Helmet>
        <title>Warranty Claim & Registration</title>
      </Helmet>

      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Box textAlign="center">
          <Button
            variant="contained"
            href={`/tools/dealerinvoice/${id}`}
            color="primary"
            sx={{ marginBottom: 3, center: 'center' }}
          >
            Invoices
          </Button>
        </Box>
        <Typography variant="h3" component="h1" paragraph>
          Warranty Claim & Registration
        </Typography>

        <DealerWarrantyRegistrationTable id={id} />
      </Container>
    </>
  );
}
